module.exports = new __parcel__URL__("shop_machines_tournament_one_competitor_trophy_v2.7919249b.png").toString();